import { themeUtils, themes } from '@zen-common/components-base';

export default themeUtils.createTheme(themes.dark);
